import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useFormikContext } from "formik";
import { constants } from "@qgiv/core-js";
import { getSessionStorageKey } from "@qgiv/core-donor";
import {
    selectStateForSessionStorage,
    setCurrentPage,
    setErrors,
    setHasSubmittedForm,
} from "../../../redux/slices/appSettingsSlice";
import { selectAllFormSettings } from "../../../redux/slices/formSettingsSlice";
import { setReceipts } from "../../../redux/slices/receiptsSlice";
import { setCurrentReceipt } from "../../../redux/slices/currentReceipt";
import { updateSubmitDonation } from "../../../redux/slices/donationDetailsSlice";
import { setDonorAccount } from "../../../redux/slices/donorAccountSlice";
import SubmitDonation from "./SubmitDonation";
import usePrepareValuesForSubmit from "../../../hooks/usePrepareValuesForSubmit";

const ConnectedSubmitDonation = () => {
    const {
        ENUMS: { CmsPageStandardizer },
    } = constants;

    const dispatch = useDispatch();
    const setSubmitDonationFalse = () => {
        dispatch(updateSubmitDonation(false));
    };

    const setReceiptData = (receiptId, receipts) => {
        dispatch(setCurrentReceipt(receiptId));
        dispatch(setReceipts(receipts));
    };

    const setDonorAccountData = (donorAccount) => {
        dispatch(setDonorAccount(donorAccount));
    };

    const setCurrentPageValue = () => {
        dispatch(setCurrentPage(CmsPageStandardizer.CONFIRMATION));
    };

    const setErrorsFromAPICall = (errors) => {
        dispatch(setErrors(errors));
    };

    const setHasSubmittedFormValue = () => {
        dispatch(setHasSubmittedForm(true));
    };

    const formSettings = useSelector(selectAllFormSettings);
    const { id: formId } = formSettings;

    const { setSubmitting } = useFormikContext();

    const sessionStorageData = useSelector(selectStateForSessionStorage);
    const sessionStorageKey = getSessionStorageKey(formId);

    const preparedValues = usePrepareValuesForSubmit({ isValidating: false });

    return (
        <SubmitDonation
            preparedValues={preparedValues}
            setSubmitDonationFalse={setSubmitDonationFalse}
            setReceiptData={setReceiptData}
            setCurrentPageValue={setCurrentPageValue}
            setDonorAccountData={setDonorAccountData}
            setErrorsFromAPICall={setErrorsFromAPICall}
            setHasSubmittedFormValue={setHasSubmittedFormValue}
            setSubmitting={setSubmitting}
            sessionStorageData={sessionStorageData}
            sessionStorageKey={sessionStorageKey}
        />
    );
};

export default ConnectedSubmitDonation;
